<template>
	<span v-if="hasBothIcons" class="icon-pair">
		<sym-icon :name="normalized[0].i" class="notification-icon" :style="icon1Style"></sym-icon>
		<sym-icon :name="normalized[1].i" class="notification-icon-secondary-outline" :style="icon2Style"></sym-icon>
		<sym-icon :name="normalized[1].i" class="notification-icon-secondary" :style="icon2Style"></sym-icon>
	</span>
	<sym-icon v-else :name="normalized[0].i" class="notification-icon" :style="icon1Style"></sym-icon>
</template>

<script setup lang="ts">
import {computed, type CSSProperties} from "vue";
import SymIcon from "@fd/helpers/SymIcon.vue";

const props = defineProps<{
	primary: string,
	secondary?: string,
	primaryColor?: string,
	secondaryColor?: string
}>();

interface Ico{i:string, c?:string}

function pushIcon(icons: Ico[], icon?: string, color?: string) {
	if (icon) {
		const iobj:Ico = {
			i: icon
		};
		if (color) iobj.c = color;
		icons.push(iobj);
	}
}

const normalized = computed<Ico[]>(() => {
	const ics:Ico[] = [];
	pushIcon(ics, props.primary, props.primaryColor);
	pushIcon(ics, props.secondary, props.secondaryColor);
	return ics;
});
const hasBothIcons = computed<boolean>(() => normalized.value.length > 1);

function iconStyle(idx:number):CSSProperties {
	const icon = normalized.value[idx];
	if (icon.c) {
		return {
			color: icon.c
		};
	}
	return null
}
const icon1Style = computed<CSSProperties>(() => iconStyle(0));
const icon2Style = computed<CSSProperties>(() => iconStyle(1));

</script>

<style>
.notification-icon {
	font-size: 24px;
	width: 32px;
	color: var(--fg);
}
.notification-icon-secondary,
.notification-icon-secondary-outline {
	position: absolute;
	right: -4px;
	bottom: -2px;
	font-size: 14px;
	width: 18px;
}
.notification-icon-secondary-outline {
	-webkit-text-stroke: 4px var(--bg);
}
.notification-icon-secondary {
	color: var(--fg);
}
.icon-pair {
	position:relative;
}
</style>